/* eslint-disable import/no-duplicates */
import { Stack } from '@cp/ds/src/components/stack';
import React from 'react';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Box } from '@cp/ds/src/components/box';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useIsStandalone } from 'src/shared/mediaQueries';
import { STANDALONE_BOTTOM_OFFSET_PX } from 'src/shared/ui/layout';
import { BottomMenuViewProps } from './model';
import { BottomMenuItem } from './menuItem';
import { BOTTOM_MENU_HEIGHT, BOTTOM_MENU_VISIBILITY_ANIMATION_DURATION_IN_MS } from './const';

export const View = React.forwardRef<HTMLDivElement, BottomMenuViewProps>(({ items, isLoading, isVisible, sx }, ref) => {
  const theme = useTheme();
  const isStandalone = useIsStandalone();
  const { pageId } = useClientWebRouteParams();
  const menuHeight = isStandalone ? BOTTOM_MENU_HEIGHT + STANDALONE_BOTTOM_OFFSET_PX : BOTTOM_MENU_HEIGHT;

  if (!items.length && !isLoading) {
    return null;
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        ref={ref}
        sx={mergeSx(
          {
            background: 'white',
            position: 'fixed',
            bottom: isVisible ? 0 : `-${menuHeight}px`,
            zIndex: 60,
            width: 1,
            alignItems: 'flex-start',
            height: `${menuHeight}px`,
            boxShadow: isVisible ? '0px 0px 16px rgba(0, 0, 0, 0.22)' : 'none',
            paddingTop: 1,
            // eslint-disable-next-line max-len
            transition: `bottom ${BOTTOM_MENU_VISIBILITY_ANIMATION_DURATION_IN_MS}ms ${theme.transitions.easing.easeInOut}, box-shadow 300ms ${theme.transitions.easing.easeInOut}`,
          },
          sx,
        )}
      >
        {isLoading ? (
          <Skeleton sx={{ width: 1, height: 1, mx: 2.5 }} />
        ) : (
          items.map((props) => {
            let content: React.ReactNode;

            if (props.renderItem) {
              content = <React.Fragment>{props.renderItem({ config: props })}</React.Fragment>;
            } else {
              content = <BottomMenuItem {...props} />;
            }

            return (
              <Box key={props.title} sx={{ flex: '1 1 0px' }}>
                {content}
              </Box>
            );
          })
        )}
      </Stack>
      {/* Spacer */}
      {ClientWebPage.Profile !== pageId && <Box sx={{ pb: 6, backgroundColor: 'background.paper' }} />}
    </>
  );
});
